export default __webpack_public_path__ + "static/media/screen7.4ffa79fb.png";